import React from "react";
import "../../pages/css/Pricing.css";

export default function PricingPlans() {
  const plans = [
    {
      title: "Basic Single Website",
      price: 149,
      features: [
        "1 page WordPress website",
        "Elementor Pro theme",
        "Domain need to bought by customer",
        "Free Hosting for 1st year",
        "Your Company Logo inserted. Note:- also can make one at good cost",
        "Web pages with your content..",
        "Contact Us page with form.",
        "Google site Map Created.",
        "Analytic Code inserted.",
        "Content need to be provider by customer can be written at extra cost (we can write SEO keyword intent as per requirement @ extra cost (on page Seo $149 with copyright free images))",
        "Email Support & Telephone / Skype Help.",
      ],
      cta: "Get in touch",
    },
    {
      title: "Basic website Development",
      price: 299,
      features: [
        "3 page WordPress website",
        "Elementor Pro theme",
        "Domain need to bought by customer",
        "Free Hosting for 1st year",
        "Your Company Logo inserted. Note:- also can make one at good cost",
        "Web pages with your content..",
        "Contact Us page with form.",
        "Google site Map Created.",
        "Analytic Code inserted.",
        "Content need to be provider by customer can be written at extra cost (we can write SEO keyword intent as per requirement @ extra cost (on page Seo $149 with copyright free images))",
        "Email Support & Telephone / Skype Help.",
      ],
      cta: "Get in touch",
    },
    {
      title: "Professional Business Website",
      price: 899,
      features: [
        "Domain need to bought by customer",
        "Free Hosting for 1st year",
        "Your Company Logo inserted. Note:- also can make one at good cost",
        "Web pages with your content..",
        "Contact Us page with form.",
        "Google site Map Created.",
        "Analytic Code inserted.",
        "Content need to be provider by customer can be written at extra cost (we can write SEO keyword intent as per requirement @ extra cost (on page Seo $149 with copyright free images))",
        "Email Support & Telephone / Skype Help.",
      ],
      cta: "Get in touch",
    },
    {
      title: "E-commerce Website upto 50 products",
      price: 1499,
      features: [
        "Domain need to bought by customer",
        "Elementor Pro theme",
        "Domain need to bought by customer",
        "Free Hosting for 1st year",
        "Your Company Logo inserted. Note:- also can make one at good cost",
        "Web pages with your content..",
        "Contact Us page with form.",
        "Google site Map Created.",
        "Analytic Code inserted.",
        "Content need to be provider by customer can be written at extra cost (we can write SEO keyword intent as per requirement @ extra cost (on page Seo $149 with copyright free images))",
        "Email Support & Telephone / Skype Help.",
      ],
      cta: "Get in touch",
    },
  ];

  return (
    <section className="pp-wrap" id="pricing">
      {/* Scoped styles */}
     

      <h2 className="title">Pricing that grows <br /> with you</h2>

      <div className="pp-grid">
        {plans.map((p, i) => (
          <article className="pp-card" key={i}>
            <div className="pp-head">
              <h3 className="pp-name">{p.title}</h3>
              <div className="pp-price">$ {p.price}</div>
            </div>
            <div className="pp-sep" />
            <div className="pp-body">
              <ul className="pp-list">
                {p.features.map((f, idx) => (
                  <li className="pp-item" key={idx}>
                    <span className="pp-tick">✓</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <button className="pp-cta">{p.cta}</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
